import { IPropsWithChildren, IPropsWithClassName } from 'interfaces';

import HeadingSize from './sizes';
import styles from './styles';

export interface HeadingProps extends IPropsWithChildren, IPropsWithClassName {
  size?: HeadingSize,
}

const Heading = ({
  size = HeadingSize.H2,
  className,
  children,
}: HeadingProps) => {
  const componentClasses = styles.component(size, className);

  switch (size) {
    case HeadingSize.H1:
      return <h2 className={componentClasses}>{children}</h2>;
    case HeadingSize.H2:
    default:
      return <h3 className={componentClasses}>{children}</h3>;
  }
};

export default Heading;
